import axios from "axios";
import { getHeader } from "../utils/utils";

const config =
  typeof window !== "undefined" ? (window.appConfig ?? {}) : {};
const port = config.API_PORT ?? process.env.REACT_APP_API_PORT;
const API_URL =
  (config.PROTOCOL ?? process.env.REACT_APP_PROTOCOL) +
  (config.HOSTNAME ?? process.env.REACT_APP_HOSTNAME) +
  (port ? ":" + port : "");
class DataService {
  getData(url, token) {
    return axios({
      method: "get",
      url: API_URL + url,
      headers: getHeader(token),
      withCredentials: true,
      data: {},
    });
  }
}

const dataServiceInstance = new DataService();
export default dataServiceInstance;
